export function extractValueAsArray(value: unknown) {
  return Array.isArray(value) ? value : value != null ? [value] : [];
}
